export function stripActionMessage(message: string): string {
  if (message.length < 10) {
    // Action messages cannot be shorter than 10 characters.
    return message;
  }

  if (message.slice(0, 8) === '\u0001ACTION ' && message[message.length - 1] === '\u0001') {
    return message.slice(8, message.length - 1);
  }

  return message;
}
